<template>
    <div class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" :src="backIcon" @click="moving()" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Nama Perusahaan</label>
                        <input 
                            class="form-control" 
                            :disabled="datas.nama!='' && datas.nama!='-'"
                            v-model="nama"
                            placeholder="Nama PJTK"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Nama Perjanjian</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.namaPerjanjianKontrak.$model"
                            :class="{ 'is-invalid':$v.namaPerjanjianKontrak.$error, 'is-valid': !$v.namaPerjanjianKontrak.$invalid }"
                            placeholder="Nama Perjanjian Kontrak"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Nomor Perjanjian</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.nomorPerjanjianKontrak.$model"
                            :class="{ 'is-invalid':$v.nomorPerjanjianKontrak.$error, 'is-valid': !$v.nomorPerjanjianKontrak.$invalid }"
                            placeholder="Nomor Perjanjian Kontrak"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Tanggal Mulai Perjanjian</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.tanggalMulaiPerjanjian.$model"
                            :class="{ 'is-invalid':$v.tanggalMulaiPerjanjian.$error, 'is-valid': !$v.tanggalMulaiPerjanjian.$invalid }"
                            placeholder="Tanggal Mulai Perjanjian"
                            type="date"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Tanggal Selesai Perjanjian</label>
                        <input 
                            class="form-control" 
                            :disabled="tanggalMulaiPerjanjian==''"
                            :min="tanggalMulaiPerjanjian"
                            v-model.trim="$v.tanggalAkhirPerjanjian.$model"
                            :class="{ 'is-invalid':$v.tanggalAkhirPerjanjian.$error, 'is-valid': !$v.tanggalAkhirPerjanjian.$invalid }"
                            placeholder="Tanggal Selesai Perjanjian"
                            type="date"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Tamggal Cut Off BAUK PO</label>
                        <model-select :options="dateBaukPo"
                            class="form-control model-select"
                            v-model.trim="$v.tanggalCutOffBaukPo.$model"
                            :class="{ 'select-invalid':$v.tanggalCutOffBaukPo.$error, 'select-valid': !$v.tanggalCutOffBaukPo.$invalid }"
                            placeholder="Tanggal Cut Off BAUK PO">
                        </model-select>
                    </CCol>
                    <CCol sm="6">
                        <label>Tanggal Cut Off BAUK NON PO</label>
                        <model-select :options="dateBaukNonPo"
                            class="form-control model-select"
                            v-model.trim="$v.tanggalCutOffBaukNonPo.$model"
                            :class="{ 'is-invalid select-invalid':$v.tanggalCutOffBaukNonPo.$error, 'is-valid select-valid': !$v.tanggalCutOffBaukNonPo.$invalid }"
                            placeholder="Tanggal Cut Off BAUK NON PO">
                        </model-select>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Nama Penanggung Jawab</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.namaPenanggungJawab.$model"
                            :class="{ 'is-invalid':$v.namaPenanggungJawab.$error, 'is-valid': !$v.namaPenanggungJawab.$invalid }"
                            placeholder="Nama Penanggung Jawab"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Fee Management (%)</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.feeManagement.$model"
                            :class="{ 'is-invalid':$v.feeManagement.$error, 'is-valid': !$v.feeManagement.$invalid }"
                            placeholder="Fee Management"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            maxlength="2"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
                <CRow class="mb-3 mt-3">
                    <CCol sm="12">
                        <h5>Nominal Lembur</h5>
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="6">
                        <label>Nominal upah lembur pada hari kerja (Rp.) / Jam</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.hariKerja.$model"
                            @input="inputNominal('1')"
                            :class="{ 'is-invalid':$v.hariKerja.$error, 'is-valid': !$v.hariKerja.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Nominal lembur hari kerja"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Nominal upah lembur pada cuti bersama (Rp.) / Jam</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.cutiBersama.$model"
                            @input="inputNominal('2')"
                            :class="{ 'is-invalid':$v.cutiBersama.$error, 'is-valid': !$v.cutiBersama.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Nominal lembur cuti bersama"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Nominal upah lembur pada hari raya keagamaan (Rp.) / Jam</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.hariKeagamaan.$model"
                            @input="inputNominal('3')"
                            :class="{ 'is-invalid':$v.hariKeagamaan.$error, 'is-valid': !$v.hariKeagamaan.$invalid }"
                            placeholder="Nominal lembur hari raya keagamaan"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Nominal upah lembur pada hari libur pemerintah (Rp.) / Jam</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.hariPemerintah.$model"
                            @input="inputNominal('4')"
                            :class="{ 'is-invalid':$v.hariPemerintah.$error, 'is-valid': !$v.hariPemerintah.$invalid }"
                            placeholder="Nominal lembur hari libur pemerintah"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            type="text"
                        />
                    </CCol>
                </CRow>
                <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
                <CRow class="mb-3 mt-3">
                    <CCol sm="12">
                        <h5>Jadwal Pembagian Premi</h5>
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="2">
                        <label>Pagi (Jam Mulai)</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.pagiMulai.$model"
                            :class="{ 'is-invalid':$v.pagiMulai.$error, 'is-valid': !$v.pagiMulai.$invalid }"
                            placeholder="Pagi (Jam Mulai)"
                            type="time"
                        />
                    </CCol>
                    <CCol sm="2">
                        <label>Pagi (Jam Selesai)</label>
                        <input 
                            class="form-control" 
                            :disabled="pagiMulai==''"
                            v-model.trim="$v.pagiSelesai.$model"
                            :class="{ 'is-invalid':$v.pagiSelesai.$error, 'is-valid': !$v.pagiSelesai.$invalid }"
                            placeholder="Pagi (Jam Selesai)"
                            type="time"
                        />
                    </CCol>
                    <CCol sm="2">
                        <label>Siang (Jam Mulai)</label>
                        <input 
                            class="form-control" 
                            :disabled="pagiMulai==''||pagiSelesai==''"
                            v-model.trim="$v.siangMulai.$model"
                            :class="{ 'is-invalid':$v.siangMulai.$error, 'is-valid': !$v.siangMulai.$invalid }"
                            placeholder="Siang (Jam Mulai)"
                            type="time"
                        />
                    </CCol>
                    <CCol sm="2">
                        <label>Siang (Jam Selesai)</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.siangSelesai.$model"
                            :disabled="siangMulai==''"
                            :class="{ 'is-invalid':$v.siangSelesai.$error, 'is-valid': !$v.siangSelesai.$invalid }"
                            placeholder="Siang (Jam Selesai)"
                            type="time"
                        />
                    </CCol>
                    <CCol sm="2">
                        <label>Malam (Jam Mulai)</label>
                        <input 
                            class="form-control" 
                            :disabled="pagiMulai==''||pagiSelesai==''||siangMulai==''||siangSelesai==''"
                            v-model.trim="$v.malamMulai.$model"
                            :class="{ 'is-invalid':$v.malamMulai.$error, 'is-valid': !$v.malamMulai.$invalid }"
                            placeholder="Malam (Jam Mulai)"
                            type="time"
                        />
                    </CCol>
                    <CCol sm="2">
                        <label>Malam (Jam Selesai)</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.malamSelesai.$model"
                            :disabled="malamMulai==''"
                            :class="{ 'is-invalid':$v.malamSelesai.$error, 'is-valid': !$v.malamSelesai.$invalid }"
                            placeholder="Malam (Jam Selesai)"
                            type="time"
                        />
                    </CCol>
                </CRow>
                <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
                <CRow class="mb-3 mt-3">
                    <CCol sm="12">
                        <h5>Nominal Premi Hari Kerja</h5>
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="4">
                        <label>Pagi</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.premiHariKerjaPagi.$model"
                            @input="inputNominal('premiHariKerjaPagi')"
                            :class="{ 'is-invalid':$v.premiHariKerjaPagi.$error, 'is-valid': !$v.premiHariKerjaPagi.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Nominal Premi Hari Kerja (Pagi)"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="4">
                        <label>Siang</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.premiHariKerjaSiang.$model"
                            @input="inputNominal('premiHariKerjaSiang')"
                            :class="{ 'is-invalid':$v.premiHariKerjaSiang.$error, 'is-valid': !$v.premiHariKerjaSiang.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Nominal Premi Hari Kerja (Siang)"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="4">
                        <label>Malam</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.premiHariKerjaMalam.$model"
                            @input="inputNominal('premiHariKerjaMalam')"
                            :class="{ 'is-invalid':$v.premiHariKerjaMalam.$error, 'is-valid': !$v.premiHariKerjaMalam.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Nominal Premi Hari Kerja (Malam)"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
                <CRow class="mb-3 mt-3">
                    <CCol sm="12">
                        <h5>Nominal Premi Cuti Bersama</h5>
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="4">
                        <label>Pagi</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.premiCutiBersamaPagi.$model"
                            @input="inputNominal('premiCutiBersamaPagi')"
                            :class="{ 'is-invalid':$v.premiCutiBersamaPagi.$error, 'is-valid': !$v.premiCutiBersamaPagi.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Nominal Premi Cuti Bersama (Pagi)"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="4">
                        <label>Siang</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.premiCutiBersamaSiang.$model"
                            @input="inputNominal('premiCutiBersamaSiang')"
                            :class="{ 'is-invalid':$v.premiCutiBersamaSiang.$error, 'is-valid': !$v.premiCutiBersamaSiang.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Nominal Premi Cuti Bersama (Siang)"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="4">
                        <label>Malam</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.premiCutiBersamaMalam.$model"
                            @input="inputNominal('premiCutiBersamaMalam')"
                            :class="{ 'is-invalid':$v.premiCutiBersamaMalam.$error, 'is-valid': !$v.premiCutiBersamaMalam.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Nominal Premi Cuti Bersama (Malam)"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
                <CRow class="mb-3 mt-3">
                    <CCol sm="12">
                        <h5>Nominal Premi Hari Libur Pemerintah</h5>
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="4">
                        <label>Pagi</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.premiHariLiburPagi.$model"
                            @input="inputNominal('premiHariLiburPagi')"
                            :class="{ 'is-invalid':$v.premiHariLiburPagi.$error, 'is-valid': !$v.premiHariLiburPagi.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Nominal Premi Hari Libur (Pagi)"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="4">
                        <label>Siang</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.premiHariLiburSiang.$model"
                            @input="inputNominal('premiHariLiburSiang')"
                            :class="{ 'is-invalid':$v.premiHariLiburSiang.$error, 'is-valid': !$v.premiHariLiburSiang.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Nominal Premi Hari Libur (Siang)"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="4">
                        <label>Malam</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.premiHariLiburMalam.$model"
                            @input="inputNominal('premiHariLiburMalam')"
                            :class="{ 'is-invalid':$v.premiHariLiburMalam.$error, 'is-valid': !$v.premiHariLiburMalam.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Nominal Premi Hari Libur (Malam)"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
                <CRow class="mb-3 mt-3">
                    <CCol sm="12">
                        <h5>Nominal Premi Hari Raya</h5>
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="4">
                        <label>Pagi</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.premiHariRayaPagi.$model"
                            @input="inputNominal('premiHariRayaPagi')"
                            :class="{ 'is-invalid':$v.premiHariRayaPagi.$error, 'is-valid': !$v.premiHariRayaPagi.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Nominal Premi Hari Raya (Pagi)"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="4">
                        <label>Siang</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.premiHariRayaSiang.$model"
                            @input="inputNominal('premiHariRayaSiang')"
                            :class="{ 'is-invalid':$v.premiHariRayaSiang.$error, 'is-valid': !$v.premiHariRayaSiang.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Nominal Premi Hari Raya (Siang)"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="4">
                        <label>Malam</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.premiHariRayaMalam.$model"
                            @input="inputNominal('premiHariRayaMalam')"
                            :class="{ 'is-invalid':$v.premiHariRayaMalam.$error, 'is-valid': !$v.premiHariRayaMalam.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Nominal Premi Hari Raya (Malam)"
                            type="text"
                        />
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-button-submit">
            <CCol sm="12">
                <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton @click="submitForm()" class="btn btn-edit-submit">
                    <span v-if="loading == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import {DataApi} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import { validationMixin } from 'vuelidate'
export default {
    props: ['isDetail', 'isData'],
    mixins: [validationMixin],
    validations: {
        namaPerjanjianKontrak: {
            required,
        },
        nomorPerjanjianKontrak: {
            required,
        },
        tanggalMulaiPerjanjian: {
            required,
        },
        tanggalAkhirPerjanjian: {
            required,
        },
        tanggalCutOffBaukPo: {
            value: {
                required
            }
        },
        tanggalCutOffBaukNonPo: {
            value: {
                required
            },
        },
        namaPenanggungJawab: {
            required
        },
        feeManagement: {
            required
        },
        hariKerja: {
            required
        },
        cutiBersama: {
            required
        },
        hariKeagamaan: {
            required
        },
        hariPemerintah: {
            required
        },
        pagiMulai: {
            required
        },
        pagiSelesai: {
            required
        },
        siangMulai: {
            required: (function() {
                if(this.siangMulai != '') {
                    if(this.siangMulai < this.pagiSelesai) {
                        alert("Jam masuk siang tidak boleh kurang dari jam pulang pagi")
                        return false
                    } else {
                        return true
                    }
                } else {
                    return ''
                }
            })
        },
        siangSelesai: {
            required
        },
        malamMulai: {
            required: (function() {
                if(this.malamMulai != '') {
                    if(this.malamMulai < this.siangSelesai) {
                        alert("Jam masuk malam tidak boleh kurang dari jam pulang siang")
                        return false
                    } else {
                        return true
                    }
                } else {
                    return ''
                }
            })
        },
        malamSelesai: {
            required: (function() {
                if(this.malamSelesai != '') {
                    if(this.malamSelesai > this.pagiMulai) {
                        alert("Jam selesai malam tidak boleh lebih dari jam mulai pagi")
                        return false
                    } else {
                        return true
                    }
                } else {
                    return ''
                }
            })
        },
        premiHariKerjaPagi: {
            required
        },
        premiHariKerjaSiang: {
            required
        },
        premiHariKerjaMalam: {
            required
        },
        premiCutiBersamaPagi: {
            required
        },
        premiCutiBersamaSiang: {
            required
        },
        premiCutiBersamaMalam: {
            required
        },
        premiHariLiburPagi: {
            required
        },
        premiHariLiburSiang: {
            required
        },
        premiHariLiburMalam: {
            required
        },
        premiHariRayaPagi: {
            required
        },
        premiHariRayaSiang: {
            required
        },
        premiHariRayaMalam: {
            required
        },
    },
    components: {
        ModelSelect
    },
    data() {
        return {
            flag2: '0',

            loading: false,
            details: false,
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            datas: [],
            dateBaukPo: [],
            dateBaukNonPo: [],

            nama: '',
            namaPerjanjianKontrak: '',
            nomorPerjanjianKontrak: '',
            tanggalMulaiPerjanjian: '',
            tanggalAkhirPerjanjian: '',
            tanggalCutOffBaukPo: {
                text: '',
                value: ''
            },
            tanggalCutOffBaukNonPo: {
                text: '',
                value: ''
            },
            namaPenanggungJawab: '',
            feeManagement: '',
            hariKerja: '',
            cutiBersama: '',
            hariKeagamaan: '',
            hariPemerintah: '',

            pagiMulai: '',
            pagiSelesai: '',
            siangMulai: '',
            siangSelesai: '',
            malamMulai: '',
            malamSelesai: '',

            premiHariKerjaPagi: '',
            premiHariKerjaSiang: '',
            premiHariKerjaMalam: '',
            premiCutiBersamaPagi: '',
            premiCutiBersamaSiang: '',
            premiCutiBersamaMalam: '',
            premiHariLiburPagi: '',
            premiHariLiburSiang: '',
            premiHariLiburMalam: '',
            premiHariRayaPagi: '',
            premiHariRayaSiang: '',
            premiHariRayaMalam: '',
        }
    },
    methods: {
        moving() {
            this.details = false
            this.$v.$reset()
            this.$emit('goDetail', false)
        },
        pharData() {
            let li = this.datas
            let malam = li.premiMalam
            let siang = li.premiSiang
            let pagi = li.premiPagi
            this.pagiMulai = pagi.jamMulai == '' ? '' : pagi.jamMulai.split(":00.")[0]
            this.pagiSelesai = pagi.jamSelesai == '' ? '' : pagi.jamSelesai.split(":00.")[0]
            this.siangMulai = siang.jamMulai == '' ? '' : siang.jamMulai.split(":00.")[0]
            this.siangSelesai = siang.jamSelesai == '' ? '' : siang.jamSelesai.split(":00.")[0]
            this.malamMulai = malam.jamMulai == '' ? '' : malam.jamMulai.split(":00.")[0]
            this.malamSelesai = malam.jamSelesai == '' ? '' : malam.jamSelesai.split(":00.")[0]
            this.premiHariKerjaPagi = pagi.hariKerja
            this.premiHariKerjaSiang = siang.hariKerja
            this.premiHariKerjaMalam = malam.hariKerja
            this.premiCutiBersamaPagi = pagi.cutiBersama
            this.premiCutiBersamaSiang = siang.cutiBersama
            this.premiCutiBersamaMalam = malam.cutiBersama
            this.premiHariLiburPagi = pagi.hariLibur
            this.premiHariLiburSiang = siang.hariLibur
            this.premiHariLiburMalam = malam.hariLibur
            this.premiHariRayaPagi = pagi.hariRaya
            this.premiHariRayaSiang = siang.hariRaya
            this.premiHariRayaMalam = malam.hariRaya
            this.nama = li.nama
            this.namaPerjanjianKontrak = li.namaPerjanjianKontrak
            this.nomorPerjanjianKontrak = li.nomorPerjanjianKontrak
            this.tanggalMulaiPerjanjian = li.tanggalMulaiPerjanjian
            this.tanggalAkhirPerjanjian = li.tanggalAkhirPerjanjian
            this.tanggalCutOffBaukPo.value = li.tanggalCutOffBaukPo
            this.tanggalCutOffBaukNonPo.value = li.tanggalCutOffBaukNonPo
            this.namaPenanggungJawab = li.namaPenanggungJawab
            this.feeManagement = li.feeManagement
            this.cutiBersama = li.lemburCutiBersama
            this.hariKeagamaan = li.lemburHariRaya
            this.hariPemerintah = li.lemburHariLibur
            this.hariKerja = li.lemburHariKerja
            this.inputNominal('1')
            this.inputNominal('2')
            this.inputNominal('3')
            this.inputNominal('4')
            this.inputNominal('premiHariKerjaPagi')
            this.inputNominal('premiHariKerjaSiang')
            this.inputNominal('premiHariKerjaMalam')
            this.inputNominal('premiCutiBersamaPagi')
            this.inputNominal('premiCutiBersamaSiang')
            this.inputNominal('premiCutiBersamaMalam')
            this.inputNominal('premiHariLiburPagi')
            this.inputNominal('premiHariLiburSiang')
            this.inputNominal('premiHariLiburMalam')
            this.inputNominal('premiHariRayaPagi')
            this.inputNominal('premiHariRayaSiang')
            this.inputNominal('premiHariRayaMalam')
        },
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
            } else {
                this.goSave()
                this.loading = true
            }
        },
        goSave() {
            let payload = {
                feeManagement: this.feeManagement,
                idPerusahaanKontrak: this.datas.idPerusahaanKontrak,
                namaPenanggungJawab: this.namaPenanggungJawab,
                namaPerjanjianKontrak: this.namaPerjanjianKontrak,
                nomorPerjanjianKontrak: this.nomorPerjanjianKontrak,
                tanggalAkhirPerjanjian: this.tanggalAkhirPerjanjian,
                lemburCutiBersama: this.clearFormat(this.cutiBersama),
                lemburHariKerja: this.clearFormat(this.hariKerja),
                lemburHariLibur: this.clearFormat(this.hariPemerintah),
                lemburHariRaya: this.clearFormat(this.hariKeagamaan),
                tanggalCutOffBaukNonPo: this.tanggalCutOffBaukNonPo.value,
                tanggalCutOffBaukPo: this.tanggalCutOffBaukPo.value,
                tanggalMulaiPerjanjian: this.tanggalMulaiPerjanjian,
                premiMalam: {
                    cutiBersama: this.clearFormat(this.premiCutiBersamaMalam),
                    hariKerja: this.clearFormat(this.premiHariKerjaMalam),
                    hariLibur: this.clearFormat(this.premiHariLiburMalam),
                    hariRaya: this.clearFormat(this.premiHariRayaMalam),
                    jamMulai: this.malamMulai,
                    jamSelesai: this.malamSelesai
                },
                premiPagi: {
                    cutiBersama: this.clearFormat(this.premiCutiBersamaPagi),
                    hariKerja: this.clearFormat(this.premiHariKerjaPagi),
                    hariLibur: this.clearFormat(this.premiHariLiburPagi),
                    hariRaya: this.clearFormat(this.premiHariRayaPagi),
                    jamMulai: this.pagiMulai,
                    jamSelesai: this.pagiSelesai
                },
                premiSiang: {
                    cutiBersama: this.clearFormat(this.premiCutiBersamaSiang),
                    hariKerja: this.clearFormat(this.premiHariKerjaSiang),
                    hariLibur: this.clearFormat(this.premiHariLiburSiang),
                    hariRaya: this.clearFormat(this.premiHariRayaSiang),
                    jamMulai: this.siangMulai,
                    jamSelesai: this.siangSelesai
                },
            }
            DataApi.post("perusahaan_kontrak/save", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.details = false
                this.$v.$reset()
                let sendParam = {
                    suc: this.success,
                    resp: this.alertMess
                }
                this.$emit('goUpdate', sendParam)
                this.loading = false
                this.currentAlertCounter = 7
            })
        },
        getDates() {
            var i = 0
            this.dateBaukPo = []
            this.dateBaukNonPo = []
            for(i=0;i<31;i++) {
                let push = {
                    value: (i+1).toString(),
                    text: i==30? (i+1).toString() + ' (Every End of Month)' : (i+1).toString()
                }
                this.dateBaukPo.push(push)
                this.dateBaukNonPo.push(push)
            }
            this.pharData()
        },
        inputNominal(val) {
            let numb = ''
            if(val == '1') {
                numb = this.hariKerja
            } else if(val == '2') {
                numb = this.cutiBersama
            } else if(val == '3') {
                numb = this.hariKeagamaan
            } else if(val == '4') {
                numb = this.hariPemerintah
            } else if(val == 'premiHariKerjaPagi') {
                numb = this.premiHariKerjaPagi
            } else if(val == 'premiHariKerjaSiang') {
                numb = this.premiHariKerjaSiang
            } else if(val == 'premiHariKerjaMalam') {
                numb = this.premiHariKerjaMalam
            } else if(val == 'premiCutiBersamaPagi') {
                numb = this.premiCutiBersamaPagi
            } else if(val == 'premiCutiBersamaSiang') {
                numb = this.premiCutiBersamaSiang
            } else if(val == 'premiCutiBersamaMalam') {
                numb = this.premiCutiBersamaMalam
            } else if(val == 'premiHariLiburPagi') {
                numb = this.premiHariLiburPagi
            } else if(val == 'premiHariLiburSiang') {
                numb = this.premiHariLiburSiang
            } else if(val == 'premiHariLiburMalam') {
                numb = this.premiHariLiburMalam
            } else if(val == 'premiHariRayaPagi') {
                numb = this.premiHariRayaPagi
            } else if(val == 'premiHariRayaSiang') {
                numb = this.premiHariRayaSiang
            } else if(val == 'premiHariRayaMalam') {
                numb = this.premiHariRayaMalam
            }
            var number_string = numb.toString().replace(/[^,\d]/g, '')
            var split           = number_string.split(',')
            var sisa             = split[0].length % 3
            var rupiah             = split[0].substr(0, sisa)
            var ribuan             = split[0].substr(sisa).match(/\d{3}/gi)
            var prefix = "Rp. "
        
            // tambahkan titik jika yang di input sudah menjadi angka satuan ribuan
            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }
        
            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            let hasil = prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');

            if(val == '1') {
                this.hariKerja = hasil
            } else if(val == '2') {
                this.cutiBersama = hasil
            } else if(val == '3') {
                this.hariKeagamaan = hasil
            } else if(val == '4') {
                this.hariPemerintah = hasil
            } else if(val == 'premiHariKerjaPagi') {
                this.premiHariKerjaPagi = hasil
            } else if(val == 'premiHariKerjaSiang') {
                this.premiHariKerjaSiang = hasil
            } else if(val == 'premiHariKerjaMalam') {
                this.premiHariKerjaMalam = hasil
            } else if(val == 'premiCutiBersamaPagi') {
                this.premiCutiBersamaPagi = hasil
            } else if(val == 'premiCutiBersamaSiang') {
                this.premiCutiBersamaSiang = hasil
            } else if(val == 'premiCutiBersamaMalam') {
                this.premiCutiBersamaMalam = hasil
            } else if(val == 'premiHariLiburPagi') {
                this.premiHariLiburPagi = hasil
            } else if(val == 'premiHariLiburSiang') {
                this.premiHariLiburSiang = hasil
            } else if(val == 'premiHariLiburMalam') {
                this.premiHariLiburMalam = hasil
            } else if(val == 'premiHariRayaPagi') {
                this.premiHariRayaPagi = hasil
            } else if(val == 'premiHariRayaSiang') {
                this.premiHariRayaSiang = hasil
            } else if(val == 'premiHariRayaMalam') {
                this.premiHariRayaMalam = hasil
            }
        },
        clearFormat(val) {
            let fix = ''
            let clear = ''
            if(val[0] == 'R') {
                clear = val.replace("Rp. ", '')
                var i
                for(i=0;i<clear.length;i++) {
                    if(clear[i] == '.') {
                        //
                    } else {
                        fix += clear[i]
                    }
                }
            } else {
                fix = val
            }
            return fix
        }
    },
    watch: {
        isDetail() {
            if(this.isDetail == true) {
                this.details = true
                this.$emit('goDetail', true)
            }
        },
        pagiMulai() {
            this.pagiMulai == '' ? this.pagiSelesai = '' : ''
        },
        siangMulai() {
            this.siangMulai == '' ? this.siangSelesai = '' : ''
        },
        malamMulai() {
            this.malamMulai == '' ? this.malamSelesai = '' : ''
        },
    },
    mounted() {
        this.datas = this.isData[0]
        this.getDates()
        window.scroll({
            top:0,
            left: 0,
            behavior: 'smooth'
        });
    },
    computed: {
    }
}
</script>
<style scoped>
.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select, .area-input .autocomplete {
    background-color: white;
    margin-bottom: 20px;
}

.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
input:disabled {
    opacity: 0.7;
}
</style>